import Button from '@mui/material/Button';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { CONSTANTS } from '../../../constants/constants';
import { useContext } from 'react';
import { useSnackbar } from 'notistack';
import { ComponentContext } from '../../../ContextWrappers/NRComponentContextWrapper';
import { useTheme } from '@mui/material/styles';

export default function ReportBreadcrumb({ params }) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const { asset } = useContext(ComponentContext);

  const onCopyJobGUID = () => {
    navigator.clipboard.writeText(window.location.href);
    enqueueSnackbar(CONSTANTS.REPORT_URL_COPIED, {
      variant: 'success',
      preventDuplicate: true,
      autoHideDuration: 1000
    });
  };

  if (!asset?.name) return null;

  return (
    <Button
      type="button"
      variant="text"
      color="inherit"
      disableRipple
      onClick={onCopyJobGUID}
      aria-label={`Copy report URL, ${asset.name}`}
      endIcon={
        <FileCopyOutlinedIcon
          aria-hidden
          sx={{
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            marginBottom: -2,
            color: theme.palette.text.icon,
            display: 'block'
          }}
        />
      }
      sx={{
        typography: 'body2',
        p: 0,
        m: 0,
        textTransform: 'none',
        color: 'inherit',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        width: 'fit-content',
        maxWidth: '100%',
        minWidth: 'unset',
        '& .MuiButton-endIcon': {
          marginRight: 0,
          paddingBottom: theme.spacing(1.6)
        },
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&.MuiButton-text': {
          padding: 0,
          minWidth: 'unset'
        }
      }}
    >
      {asset.name}
    </Button>
  );
}
